import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Contrast"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.0277 8.88C21.8264 8.22747 21.5601 7.59681 21.2327 6.9975C20.7487 6.10801 20.1401 5.29226 19.4252 4.575C15.3246 0.474803 8.67657 0.475029 4.57623 4.5755C0.475892 8.67598 0.475892 15.324 4.57623 19.4245C8.67657 23.525 15.3246 23.5252 19.4252 19.425C20.1401 18.7077 20.7487 17.892 21.2327 17.0025C21.5601 16.4032 21.8264 15.7725 22.0277 15.12C22.6601 13.0881 22.6601 10.9119 22.0277 8.88ZM3.00021 12C3.00021 7.02944 7.02965 3 12.0002 3V21C7.02965 21 3.00021 16.9706 3.00021 12Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Contrast.vue"]]);
